/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartremovepicture4Inputs */

const en_eventaistartremovepicture4 = /** @type {(inputs: Eventaistartremovepicture4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove picture`)
};

const de_eventaistartremovepicture4 = /** @type {(inputs: Eventaistartremovepicture4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild entfernen`)
};

/**
* | output |
* | --- |
* | "Remove picture" |
*
* @param {Eventaistartremovepicture4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartremovepicture4 = /** @type {((inputs?: Eventaistartremovepicture4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartremovepicture4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartremovepicture4(inputs)
	return de_eventaistartremovepicture4(inputs)
});
export { eventaistartremovepicture4 as "eventAiStartRemovePicture" }